import { useEffect, useState } from 'react';
import styles from './leftMenuNavigation.module.scss';
import { useNavigate, useParams } from 'react-router-dom';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { isNil } from 'lodash';
import { leftMenuNavigationListProps, leftSubMenuNavigationListProps } from '../../../infrastructure/GlobalContextProvider';
import { checkAuthToken, getUserName, getUserRoleId, getaccessToken } from '../../../infrastructure/backendService';
import { SubRoutingURLs } from '../RoutingURLs';

interface LeftMenuProps {
   menuList : leftMenuNavigationListProps[];
   mainRoutePath:string;
   mainMenuStyle?:boolean;
}

const LeftMainNavigation = (props : LeftMenuProps) => {
   const currentSubMenu = Object.values(useParams())[0] || "" ;
   const [selectedMenu, setSelectedMenu] = useState<string | null>(null);
   const [selectedSubMenu, setSelectedSubMenu] = useState<string | null | undefined>(currentSubMenu);
   const navigate = useNavigate();


   useEffect(()=>{
      setSelectedSubMenu(currentSubMenu);
   },[currentSubMenu]);


   useEffect(()=>{
      if(!checkAuthToken()) {
         navigate('/')
      }
   },[getaccessToken()]);

   const getmainMenuStyle = () : boolean => {
      if(isNil(props.mainMenuStyle)) {
         return false;
      } else {
         return true;
      }
   }

   const handleMenuClick = (mainMenu: any) => {
      const mainMenuTitle = mainMenu?.title
      setSelectedMenu(mainMenuTitle);
      if(mainMenuTitle === "Office Devotee Service" && props.menuList.some((menu) => menu.title === mainMenuTitle && menu?.subMenus?.length === 0)) {
         window.open(
            `${process.env.REACT_APP_BASE_ASP_URL}/hints/manage/validate_token.asp?token=${getaccessToken()}&username=${getUserName()}&userRoleId=${getUserRoleId()}`,
            "_blank"
          );
      } else if (props.menuList.some((menu) => menu.title === mainMenuTitle && (menu?.subMenus?.length === 0 || !menu?.subMenus)) && mainMenuTitle !== "office Devotee Service") {
         navigate(`/${props.mainRoutePath}/${SubRoutingURLs?.[mainMenu?.key]}`);
      } else if (selectedMenu === mainMenuTitle) {
         setSelectedMenu(null);
      }
   };

   const handleSubMenuClick = (subMenu: any) => {
      setSelectedSubMenu(subMenu?.title);
      onNavigate(subMenu);
   };

   const onNavigate = (subMenu: any) => {
     let path = subMenu?.key;
     let prefixedPath = path;
     // Check for specific main menus
     if (selectedMenu === "Data Entry") {
       prefixedPath = `dataentry/${SubRoutingURLs?.[path]}`;
     } else if (
       selectedMenu === "Devotee Service" ||
       selectedMenu === "Devotee Management" ||
       selectedMenu === "SCM Management" ||
       selectedMenu === "Application Settings"
     ) {
       // Add additional conditions for other main menus
       prefixedPath = `devoteeService/${SubRoutingURLs?.[path]}`;
     } else if (selectedMenu === "Expense Voucher") {
       prefixedPath = `expense-voucher/${SubRoutingURLs?.[path]}`;
     } else if (selectedMenu === "Schedules") {
       prefixedPath = `schedules/${SubRoutingURLs?.[path]}`;
     } 
     if (selectedMenu === "Reports Section") {
       navigate(`/managerDashboard/ReportsSection/${SubRoutingURLs?.[path]}`, {
         state: { subRoutes: subMenu },
       });
     } else {
       navigate(`/managerDashboard/${prefixedPath}`);
     }
   };

   const renderMainMenuList = (menu:leftMenuNavigationListProps) => {
      if (menu?.subMenus?.length !== 0 || menu?.key === "OFFICE_DEVOTEE_SERVICE" || (menu?.subMenus?.length === 0 && Object.keys(SubRoutingURLs)?.includes(menu?.key || ""))) {
         return (
            <div key={menu?.id} className={styles.mainMenuContainer} id={menu.key}>
            <div className={`${styles.menuContainer} ${
                     ((selectedMenu === menu.title && getmainMenuStyle()) || (currentSubMenu === menu.title && getmainMenuStyle())) ? `${styles.active}` : ""
                  }`}  onClick={() => handleMenuClick(menu)}>
               <div
                  className={`${styles.mainMenu} ${
                     ((selectedMenu === menu.title && getmainMenuStyle()) || (currentSubMenu === menu.title && getmainMenuStyle()))? `${styles.active}` : ''
                  }`}
                 
               >
                  {menu.title}
               </div>
               <div style={{ marginLeft: 'auto', marginRight: '10px' }}>
                  {menu?.subMenus && menu?.subMenus?.length !== 0 ? (
                     <>
                        {selectedMenu === menu.title ? (
                           <KeyboardArrowUpIcon
                              sx={{
                                 fontSize: '14px',
                                 marginLeft: 'auto',
                                 fontWeight: '700',
                                 color: ((selectedMenu === menu.title && getmainMenuStyle()) || (currentSubMenu === menu.title && getmainMenuStyle())) ? "#fff" : "#882E14"
                              }}
                           />
                        ) : (
                           <KeyboardArrowDownIcon
                              sx={{
                                 fontSize: '14px',
                                 marginLeft: 'auto',
                                 fontWeight: 'bold',
                                 color: ((selectedMenu === menu.title && getmainMenuStyle()) || (currentSubMenu === menu.title && getmainMenuStyle())) ? "#fff" : "#882E14"
                              }}
                           />
                        )}{' '}
                     </>
                  ) : (
                     ''
                  )}
               </div>
            </div>
            {selectedMenu === menu.title && (
               <div className={styles.subMenuContainer} id={menu.title}>
                  {menu?.subMenus?.map((subMenuItem:leftSubMenuNavigationListProps) => (
                     <div
                        key={subMenuItem.title}
                        className={`${styles.subMenu } ${
                           (selectedSubMenu === SubRoutingURLs?.[`${subMenuItem?.key}`] || currentSubMenu === SubRoutingURLs?.[`${subMenuItem?.key}`]) ? `${styles.active}` : ''
                        }`}
                        onClick={() => handleSubMenuClick(subMenuItem)}
                        id={subMenuItem.key}
                     >
                        {subMenuItem.title}
                     </div>
                  ))}
               </div>
            )}
         </div>
         )
      }
      return
   }

   return (
      <div>
         {props.menuList?.map((menu:leftMenuNavigationListProps) => (
            renderMainMenuList(menu)
         ))}
      </div>
   );
};

export default LeftMainNavigation;
